"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function DownloadExportationPopup(_ref) {
  var title = _ref.title,
    message = _ref.message,
    url = _ref.url,
    onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: title,
    onClose: onClose,
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    button: {
      text: (0, _core.translate)('buttons.download'),
      href: url
    }
  }, message);
}
var _default = exports["default"] = DownloadExportationPopup;